import dayjs from "dayjs";
import { Table } from "react-bootstrap";
import ConditionalSpinner from "../../../components/ConditionalSpinner";
import { Organisation } from "../../../models/Organisation";
import { DateFormats } from "../../../utilities/dates";
import { useAdminGetOrganisationGeneralSettingsQuery, useGetLastOrgActivityQuery } from "../../../store/api/kinesense";

export interface OrganisationDetailsProps {
    organisation: Organisation;
    isLoading: boolean;
}

function OrganisationDetails(props: OrganisationDetailsProps) {
    const { data: generalSettings, isLoading: isLoadingSettings } = useAdminGetOrganisationGeneralSettingsQuery(
        { organisationId: props.organisation?.organisationId },
        { skip: !props.organisation?.organisationId },
    );
    const { data: lastActivityData, isLoading: isLoadingActivity } = useGetLastOrgActivityQuery(
        { organisationId: props.organisation?.organisationId },
        { skip: !generalSettings?.isTrial || !props.organisation?.organisationId },
    );

    const isLoading = props.isLoading || isLoadingSettings || isLoadingActivity;

    return (
        <section className="organisation-details">
            <ConditionalSpinner isLoading={isLoading}>
                <Table className="details-table ms-2">
                    <tbody className="px-3">
                        <tr>
                            <th>ID</th>
                            <td className="p-2">{props.organisation?.organisationId}</td>
                        </tr>
                        <tr>
                            <th>Country</th>
                            <td className="p-2">{props.organisation?.country}</td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td className="p-2">
                                {dayjs(props.organisation?.createdAt).format(DateFormats.dayMonthYear)}
                            </td>
                        </tr>
                        {generalSettings && (
                            <tr>
                                <th>Trial Mode</th>
                                <td className="p-2">{generalSettings.isTrial ? "Yes" : "No"}</td>
                            </tr>
                        )}
                        {generalSettings?.isTrial && lastActivityData?.data?.lastActivity && (
                            <tr>
                                <th>Last Activity</th>
                                <td className="p-2">
                                    {dayjs(lastActivityData.data.lastActivity).format(DateFormats.dayMonthYearWithTime)}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </ConditionalSpinner>
        </section>
    );
}

export default OrganisationDetails;
